import { render, staticRenderFns } from "./UnitedKingdom.vue?vue&type=template&id=cbd5cd24"
import script from "./UnitedKingdom.vue?vue&type=script&lang=js"
export * from "./UnitedKingdom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports